import clsx from "clsx";
import { AttsIcon } from "assets/svgComponents/PresaleBlock/ConnectWallet copy";

type DarkFooterProps = {
  /** Landing-only section links; hide on dashboard / referrals where those anchors don’t exist. */
  hideProductColumn?: boolean;
};

export function DarkFooter({ hideProductColumn = false }: DarkFooterProps) {
  const handleAnchorClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string,
  ) => {
    if (!href.startsWith("#")) return;
    e.preventDefault();
    const el = document.getElementById(href.slice(1));
    if (el) {
      const offsetPosition =
        el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  return (
    <footer className="border-t border-white/[0.06] pt-16 pb-8 px-6 relative bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto relative z-10">
        <div
          className={clsx(
            "grid grid-cols-2 gap-12 mb-14",
            hideProductColumn ? "md:grid-cols-3" : "md:grid-cols-4",
          )}
        >
          <div className="col-span-2">
            <a
              className={clsx(
                "inline-flex items-center mb-5 cursor-pointer hover:opacity-80 transition-opacity",
                hideProductColumn && "md:mb-0",
              )}
              href="/"
            >
              <AttsIcon className="size-14" />
              <span className="font-space-grotesk font-bold text-xl tracking-tight text-white">
                AGNT.Hub
              </span>
            </a>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm">
              The personal AI command center for autonomous crypto operations.
              Powered by $ATTS.
            </p>
          </div>

          {!hideProductColumn && (
            <div>
              <h4 className="text-[10px] font-bold uppercase tracking-[0.15em] mb-5 text-white/50">
                Product
              </h4>
              <div className="flex flex-col gap-3">
                {[
                  { label: "Token", href: "#token" },
                  { label: "Agents", href: "#agents" },
                  { label: "Neobank", href: "#neobank" },
                  {
                    label: "Whitepaper",
                    href: "https://docs.agnthub.ai",
                    external: true,
                  },
                  { label: "FAQ", href: "#faq" },
                ].map(({ label, href, external }) => (
                  <a
                    key={label}
                    href={href}
                    {...(external
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : {})}
                    onClick={(e) => handleAnchorClick(e, href)}
                    className="text-sm font-medium text-white/50 hover:text-white/60 transition-colors no-underline"
                  >
                    {label}
                  </a>
                ))}
              </div>
            </div>
          )}

          <div
            className={clsx(hideProductColumn && "max-w-[300px] md:ml-auto")}
          >
            <h4
              className={clsx(
                "text-[10px] font-bold uppercase tracking-[0.15em] mb-5 text-white/50",
              )}
            >
              Community
            </h4>
            <div
              className={clsx(
                "flex flex-col gap-3",
                hideProductColumn && "lg:flex-row md:gap-6",
              )}
            >
              {[
                { label: "Telegram", href: "https://t.me/agnt_ann" },
                { label: "Discord", href: "https://discord.gg/agnthub" },
                { label: "X (Twitter)", href: "https://x.com/agnt_hub" },
              ].map(({ label, href }) => (
                <a
                  key={label}
                  href={href}
                  {...(href.startsWith("http")
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                  onClick={(e) => handleAnchorClick(e, href)}
                  className="text-sm font-medium text-white/50 hover:text-white/60 transition-colors no-underline"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-white/[0.06]">
          <span className="text-xs text-white/40">
            &copy; 2026 AGNT.Hub. All rights reserved.
          </span>
        </div>
      </div>
    </footer>
  );
}
